import { HTMLAttributes } from 'react'

import { cn } from '@shared/lib/cn'

import styles from './styles.module.scss'



interface ContainerProps extends HTMLAttributes<HTMLDivElement> {
  className?: string;
}

export default function Container (props: ContainerProps) {
  const { className, ...restProps } = props

  return <div className={cn(className, styles.root)} {...restProps}></div>
}
